import { drawPointAnim, drawAngleAnim, drawLineAnim, drawCircleAnim, showSlidersAnim, showCalcLineAnim, drawAngleBgAnim, reduceOpacityAnim } from "./helpers/drawHeplers";
import { drawMovePoints } from "./helpers/drawMovePoints";

import { ANGLE_NAMES_FOR_ANIM, RADIANS } from "../../types/Config";
import { EventBus, EnumEventBus } from "../EventBus";
import { drawMoveAngles } from "./helpers/drawMoveAngleHelpers";


export async function runIntroAnimation(context, cb: () => void) {
  const {
    circle,
    LineManager,
    PointManager,
    AngleManager,
    AngleBgManager,
    SliderManager,
    calcLine,
  } = context;

  AngleManager.setVisible(false);
  SliderManager.setAllVisible(false);

  const [cCoord, cSide1Point, cSide2Point, cCircumPoint] = PointManager.getPoints().map(p => ({ x: p.x, y: p.y }));

  // Circle
  circle.radians = Array(3).fill(RADIANS[2])
  await drawCircleAnim(circle, RADIANS[2] - 2 * Math.PI, 2, true, cCoord);

  drawLineAnim(LineManager.lLine1CirSide2, cCircumPoint, cSide2Point);
  await drawLineAnim(LineManager.rLine1CirSide1, cCircumPoint, cSide1Point);
  await drawAngleAnim(AngleManager.circumAngle, ANGLE_NAMES_FOR_ANIM.circum);

  circle.radians = [RADIANS[0], RADIANS[0], RADIANS[2]]

  const finalRadian = RADIANS[1];

  await drawCircleAnim(circle, finalRadian, 1, false, cCoord);
  await drawAngleBgAnim(AngleBgManager.circumBg, finalRadian, cCoord);
  // dance
  circle.radians = RADIANS;

  await drawMovePoints([AngleBgManager.circumBg], circle, PointManager, AngleManager, LineManager);

  await drawPointAnim(PointManager.circlePoint, cCoord);

  drawLineAnim(LineManager.lLine2CenSide1, cCoord, cSide2Point);
  await drawLineAnim(LineManager.rLine2CenSide2, cCoord, cSide1Point);
  await drawMoveAngles(circle, PointManager, AngleManager);

  await drawAngleAnim(AngleManager.centerAngle, ANGLE_NAMES_FOR_ANIM.center);
  await drawAngleBgAnim(AngleBgManager.centerBg, finalRadian, cCoord);

  await drawMovePoints([AngleBgManager.circumBg, AngleBgManager.centerBg], circle, PointManager, AngleManager, LineManager);

  reduceOpacityAnim(AngleBgManager.centerBg)
  await reduceOpacityAnim(AngleBgManager.circumBg)


  // show calcLine
  EventBus.emit(EnumEventBus.setCalcForAnim)
  // draw Active Arc

  // Rotate Circle
  //  await rotateCircleAnim((radian) => drawRotationCB(radian, circle, PointManager, LineManager, AngleManager));

  showCalcLineAnim(calcLine);

  cb();
}
